import React from 'react'
import dayjs from 'dayjs';
import IconButton from '@mui/joy/IconButton';
import Checkbox from '@mui/material/Checkbox';
import CallIcon from '@mui/icons-material/Call';
import AssetSelects from './Selects/AssetSelects';
import relativeTime from 'dayjs/plugin/relativeTime';
import CreateRoundedIcon from '@mui/icons-material/CreateRounded';
import { useNavigate } from 'react-router-dom';
import { EndPoints } from '../../../../utils/apiEndpoints';
import { darkModeBackgroud } from '../../../../utils/constants';
import { CardAvatar } from '../../../../common/GlobalFunctions';
import { AssetInterface } from '../../../../models/AssetModel/Asset';
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';

dayjs.extend(relativeTime);
interface AssetCardProps {
    asset: AssetInterface;
    page: number;
    pageSize: number;
    selectedIds: string[];
    setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>
}

export const AssetCard: React.FC<AssetCardProps> = ({ asset, page, pageSize, selectedIds, setSelectedIds }) => {

    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const navigation = useNavigate();

    const isChecked = React.useMemo(() => selectedIds.some(select => select === asset.id), [selectedIds, asset.id]);
    const createdDate = React.useMemo(() => asset.createdDate ? dayjs(asset.createdDate).fromNow() : '', [asset.createdDate]);
    const isLessThanOneDayOld = React.useMemo(() => asset.createdDate ? dayjs().diff(dayjs(asset.createdDate), 'day') < 1 : false, [asset.createdDate]);

    const AssetInfo = () => {
        return <div
            title={asset?.description}
            className="d-flex flex-column gap-1"
        >
            {
                isLessThanOneDayOld
                && <div
                    className="badge fw-bold"
                    title={language['NewAssetBadge']}
                    style={{ background: '#368E7122', color: '#368E71', width: 40 }}
                >
                    New
                </div>
            }

            <div
                className={`${darkMode ? 'text-white' : 'text-muted'} d-flex flex-row align-items-center gap-1`}>
                -- |
                <div
                    className={`${darkMode ? 'text-white' : 'text-dark'}fw-bold text-truncate`}
                    style={{ fontSize: 13, maxWidth: '200px' }}
                >
                    {asset?.title}
                </div>
                #{asset?.barcode}
            </div>
            <span
                className={`d-flex flex-row gap-2 ${darkMode && 'text-white'}`}
                style={{ fontSize: 13 }}
            >
                <span>
                    <CallIcon sx={{ width: 15, height: 15 }} />
                    {asset.author?.firstname ?? ''} {asset.author?.lastname ?? ''}
                </span>
                <span
                    className={`${darkMode ? 'text-white' : 'text-muted'}`}>
                    ● {language['Created']}: {' '}
                    {createdDate}
                </span>
            </span>
        </div>
    }

    const handleCheckedItem = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;

        if (asset.id) {
            if (checked) setSelectedIds((prevSelectedIds) => [...prevSelectedIds, asset.id as string]);
            else setSelectedIds((prevSelectedIds) => prevSelectedIds.filter(id => id !== asset.id as string));
        }
    };

    return (
        <div
            className='card d-flex flex-row align-items-center gap-2 p-3 card-assets position-relative card-feedback'
            style={{ borderRadius: 2, background: darkMode ? darkModeBackgroud : 'white' }}
            role='button'
            onClick={() => navigation(`${EndPoints.ASSETS}/view/${asset.id}`)}
        >
            <span className='position-absolute showIconHover' style={{ top: 10, right: 10 }}>
                <IconButton
                    aria-label="edit"
                    title='Edit Item'
                    sx={{ color: darkMode ? 'white' : '#185EA5' }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigation(`${EndPoints.ASSETS}/edit/${asset.id}`)
                    }}
                >
                    <CreateRoundedIcon sx={{ width: 15, height: 15 }} />
                </IconButton>
            </span>
            <Checkbox
                checked={isChecked}
                onChange={(e) => handleCheckedItem(e)}
                onClick={(e) => e.stopPropagation()}
                className={`${darkMode && 'text-white'}`}
            />
            {CardAvatar('A')}
            <AssetInfo />
            <AssetSelects
                asset={asset}
                page={page}
                pageSize={pageSize}
            />
        </div>
    );
}
export default AssetCard